var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        if (typeof b !== "function" && b !== null)
            throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import React from 'react';
import { Upload as KendoUpload } from '@progress/kendo-react-upload/dist/npm/Upload';
var Upload = /** @class */ (function (_super) {
    __extends(Upload, _super);
    function Upload(props) {
        var _this = _super.call(this, props) || this;
        _this.onAdd = function (e) {
            _this.setState({
                files: e.newState
            });
        };
        _this.onRemove = function (e) {
            _this.setState({
                files: e.newState
            });
        };
        _this.onProgress = function (e) {
            _this.setState({
                files: e.newState
            });
        };
        _this.onStatusChange = function (e) {
            _this.setState({
                files: e.newState
            });
        };
        _this.state = {
            files: [],
        };
        return _this;
    }
    Upload.prototype.render = function () {
        return (_jsxs("div", { children: [_jsx(KendoUpload, __assign({}, this.props, { multiple: false, onAdd: this.onAdd, onRemove: this.onRemove, onProgress: this.onProgress, onStatusChange: this.onStatusChange, saveField: this.props.element.name, files: this.state.files })), _jsx("input", { type: 'hidden', name: this.props.element.name, value: this.state.files.length > 0 ? this.state.files[0].name : '' })] }));
    };
    return Upload;
}(React.Component));
export default Upload;
